import { expensesApi } from '../api/expensesApi'

export const getPublicCategories = async () => {
  try {
    const {
      data: { categories },
    } = await expensesApi.getPublicCategories()
    return categories
  } catch (error) {
    console.error(`Error fetching public expenses categories: `, error)
    throw error
  }
}
